const saveAndGetLocation = ({ city, country, lat, long } = {}) => {
  country && localStorage.setItem("country", country);
  city && localStorage.setItem("city", city);
  lat && localStorage.setItem("lat", lat);
  long && localStorage.setItem("long", long);
  return {
    country: localStorage.getItem("country", country) || "N/A",
    city: localStorage.getItem("city", city) || "N/A",
    lat: localStorage.getItem("lat", lat) || "N/A",
    long: localStorage.getItem("long", long) || "N/A",
    fromUtil: true,
  };
};

export { saveAndGetLocation };
